export const labels = {
    tenant: 'Alaric',
    tenantRetailPortal: 'Retail',
    tenantProPortal: 'Pro'
};
